import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UsersPageComponent} from './view/users-page/users-page.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {AccordionModule} from 'primeng/accordion';
import {SelectButtonModule} from 'primeng/selectbutton';
import {CalendarModule} from 'primeng/calendar';
import {MiscModule} from 'projects/core/src/public-api';
import {CustomerMiscModule} from '../customer/customer-misc.module';
import {CheckboxModule} from 'primeng/checkbox';
import {DesktopProjectModule} from 'projects/desktop/src/app/modules/project/desktop-project.module';
import {UserEditDialogComponent} from './view/users-page/user-edit-dialog/user-edit-dialog.component';
import {UsersFilterComponent} from './view/users-page/users-filter/users-filter.component';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {DropdownModule} from 'primeng/dropdown';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRippleModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {InputNumberModule} from 'primeng/inputnumber';
import {MultiSelectModule} from 'primeng/multiselect';
import {ColorPickerModule} from 'primeng/colorpicker';
import {AutoCompleteModule} from 'primeng/autocomplete';


@NgModule({
  declarations: [UsersPageComponent, UserEditDialogComponent, UsersFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    MatDialogModule,
    MatRippleModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    AccordionModule,
    SelectButtonModule,
    CalendarModule,
    MiscModule,
    OverlayPanelModule,
    CustomerMiscModule,
    CheckboxModule,
    DropdownModule,
    MultiSelectModule,
    ConfirmDialogModule,
    InputSwitchModule,
    InputNumberModule,
    DesktopProjectModule,
    ColorPickerModule,
    AutoCompleteModule
  ],
  entryComponents: [UserEditDialogComponent]
})
export class UsersModule {
}
